import { type FC } from 'react';

import { Link } from 'react-router-dom';

import { COMPANY } from '@shared/config';

import { LEGAL_DOCS } from '../config';

// Страница /cookies — куда ведёт ссылка «файлов cookie» из уведомления. Описывает только то,
// что реально есть на сайте: cookie Яндекс Метрики и карты Яндекса; собственных cookie сервер не ставит.
// При правке — поднять PD_DOCS_VERSION
export const CookiesText: FC = () => (
  <>
    <h2>Что такое cookie?</h2>
    <p>
      Cookie (файлы cookie) — небольшие фрагменты данных, которые сайт сохраняет в браузере на вашем
      устройстве. При следующих обращениях к сайту браузер отправляет их обратно — так сайт и
      подключённые к нему сервисы узнают устройство.
    </p>

    <h2>Как мы используем файлы cookie?</h2>
    <p>
      На сайте {COMPANY.site} cookie нужны для статистики посещений: какие страницы смотрят, откуда
      приходят посетители, удобно ли пользоваться сайтом. Для этого подключён сервис Яндекс Метрика
      с Вебвизором. Рекламу по cookie мы не показываем и сведения для рекламы никому не передаём.
    </p>
    <p>
      Выбранная тема (светлая или тёмная) и отметка о закрытии уведомления о cookie хранятся в
      браузере, в его локальном хранилище, и на сервер не отправляются. Собственных cookie наш
      сервер не устанавливает.
    </p>
    <p>
      Большинство браузеров позволяет запретить cookie или удалить уже сохранённые. Сайт при этом
      работает полностью: каталог, проекты и отправка заявки доступны и без cookie.
    </p>

    <h2>Как обрабатываются файлы cookie?</h2>
    <p>
      Cookie Яндекс Метрики устанавливает и читает сервис ООО «ЯНДЕКС». Вместе с ними сервис
      получает сведения о посещённых страницах, источнике перехода, браузере, устройстве и
      IP-адресе. Содержимое формы заявки скрыто от записи и в аналитику не передаётся.
    </p>
    <p>
      На странице контактов встроена карта Яндекса: при её загрузке Яндекс может использовать свои
      cookie в соответствии с{' '}
      <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">
        политикой конфиденциальности Яндекса
      </a>
      .
    </p>

    <h2>Какие виды файлов cookie используются?</h2>
    <ul>
      <li>
        <strong>Постоянные</strong> — cookie Яндекс Метрики, по которым сервис отличает новое
        посещение от повторного. Хранятся до истечения срока, заданного сервисом, или пока вы их не
        удалите.
      </li>
      <li>
        <strong>Сессионные (временные)</strong> — действуют, пока вы находитесь на сайте, и
        удаляются после закрытия браузера.
      </li>
      <li>
        <strong>Сторонние</strong> — cookie карты Яндекса на странице контактов: принадлежат домену
        Яндекса, а не нашему сайту.
      </li>
    </ul>

    <h2>Важно</h2>
    <ul>
      <li>
        Файлы cookie — не вирус и не программа: они не могут заразить или повредить устройство.
      </li>
      <li>
        Cookie не дают сайту доступа к файлам, контактам и другим данным на вашем устройстве —
        только к сведениям о посещении сайта.
      </li>
      <li>Запрет cookie в браузере не ограничивает работу сайта.</li>
    </ul>

    <p>
      Как мы обрабатываем персональные данные, описано в документе{' '}
      <Link to={LEGAL_DOCS.privacy.path}>{LEGAL_DOCS.privacy.title}</Link>.
    </p>
  </>
);
